import { LanguageSelector } from "@/components/LanguageSelector/LanguageSelector";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const LanguageSettings = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "32px",
        flexDirection: "column",
        width: "552px", // match profile dialog size
        height: "617px", // match profile dialog size
        maxWidth: "100%",
        maxHeight: "100%",
        "& > .MuiBox-root": {
          display: "flex",
          flexDirection: "column",
          width: "100%"
        }
      }}
    >
      <Box component="div" sx={{ gap: "16px" }}>
        <Typography>{t("label.language")}</Typography>
        <LanguageSelector size="small" />
      </Box>
    </Box>
  );
};
